import { ReactNode, useEffect } from "react"

const TIME_MACHINE_KEY = "time-machine"
const TIME_MACHINE_ENABLED_KEY = "time-machine-enabled"

let manualCurrentTime: Date | null = localStorage.getItem(TIME_MACHINE_KEY)
   ? new Date(localStorage.getItem(TIME_MACHINE_KEY) as string)
   : null
let isEnabled = localStorage.getItem(TIME_MACHINE_ENABLED_KEY) === "true"

export function getNow(): Date {
   if (isEnabled && manualCurrentTime) {
      return manualCurrentTime
   }

   return new Date()
}

export function setNow(date: Date) {
   manualCurrentTime = date
   localStorage.setItem(TIME_MACHINE_KEY, date.toISOString())
   // Force a re-render of all components using getNow
   window.dispatchEvent(new Event("time-machine-update"))
}

export function resetTimeMachine() {
   manualCurrentTime = null
   localStorage.removeItem(TIME_MACHINE_KEY)
   // Force a re-render of all components using getNow
   window.dispatchEvent(new Event("time-machine-update"))
}

export function isTimeMachineEnabled(): boolean {
   return isEnabled
}

export function setTimeMachineEnabled(enabled: boolean) {
   isEnabled = enabled
   localStorage.setItem(TIME_MACHINE_ENABLED_KEY, enabled.toString())
   window.dispatchEvent(new Event("time-machine-update"))
}

interface TimeMachineProviderProps {
   children: ReactNode
}

export function TimeMachineProvider({ children }: TimeMachineProviderProps) {
   return children
}

export function useTimeMachine() {
   useEffect(() => {
      if (isTimeMachineEnabled()) {
         const ret = setInterval(() => {
            window.dispatchEvent(new Event("time-machine-update"))
         }, 1000 * 60)
         return () => clearInterval(ret)
      }
   }, [])

   return {
      now: getNow(),
      isEnabled: isTimeMachineEnabled(),
      setNow,
      setEnabled: setTimeMachineEnabled,
      reset: resetTimeMachine,
   }
}
